import React, { useEffect, useState } from "react";
import RejectedListCard from "./RejectedListCard";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "components/pagination/Pagination";
import { setRejectedRecentBooking } from "redux/actions/super-admin/RejectedRecentBookingsAction";
import pendingReq from "../../../../../assets/img/icons/customIcons/pending-req.svg";

function RejectedList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  setSearchFormData,
  data,
  companyId,
  toggle,
  list,
  handleClearDate,
}) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [showToggle, setShowToggle] = useState(false);

  const fetchResultRejectedListRequests = useSelector(
    (state) => state.RejectedRecentBookingReducer.result
  );
  const fetchResultRejectedListRequestsLoader = useSelector(
    (state) => state.RejectedRecentBookingReducer.loader
  );
  useEffect(() => {
    setTitle(data);

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  const handlePagination = (tab) => {
    // setSearchFormData({
    //   ...searchFormData,
    //   page: tab,
    // })
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(
      setRejectedRecentBooking("1", "1", "rejected", finalData, companyId)
    );
  };
  return (
    <>
      <Row className="mb-2">
        <Col md="12">
          <h3 className="tab-title">{`${title} (${
            fetchResultRejectedListRequests?.itemCount
              ? fetchResultRejectedListRequests?.itemCount
              : "0"
          })`}</h3>
        </Col>
        {/* <Col lg="7" md="12">
          <EmployeeSearchbar
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleSearch}
          />
          <AnimatedSearchBar
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleSearch}
          />
        </Col> */}
        <Col lg="5" md="12">
          <div className="common-outer-filter">
            {list && (
              <div className="btn-group new-cutom-filter ">
                <button
                  type="button"
                  onClick={() => setShowToggle(!showToggle)}
                  className={"btn dropdown-toggle mr-3"}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img alt="" src={pendingReq} width={"18px"} />
                </button>
                <div
                  className={`dropdown-menu dropdown-menu-right  ${
                    showToggle ? "show" : ""
                  }`}
                >
                  {list?.map((item, key) => (
                    <button
                      key={key}
                      className="dropdown-item"
                      onClick={() => toggle({ target: { value: item?.tabId } })}
                      type="button"
                    >
                      {item?.title}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* <SearchDate
              handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
              handleSearch={handleSearch}
              clearDate={handleClearDate}
            /> */}
          </div>
        </Col>
      </Row>

      <RejectedListCard loader={fetchResultRejectedListRequestsLoader} />

      <div
        style={{
          display: fetchResultRejectedListRequestsLoader ? "none" : "contents",
        }}
      >
        <PaginationComponent
          totalCount={fetchResultRejectedListRequests?.itemCount}
          handlePagination={handlePagination}
          activePage={fetchResultRejectedListRequests?.activePage}
        />
      </div>
      {/* {!fetchResultRejectedListRequestsLoader && 
       <PaginationComponent totalCount={fetchResultRejectedListRequests?.itemCount} handlePagination={handlePagination}/>}
      */}
    </>
  );
}

export default RejectedList;
